module.exports = __webpack_public_path__ + "static/media/apporoach_man_img.0f15c002.png";